import AppStore from "./AppStore";
import { buildClassName } from "./util";

// id: "dd3879f0-3f21-403a-aa00-045afeb31cb2"
// title: "Member Pages"
// type: :html
// key: "member-pages"
// parent_id: nil
export function MemberPagesDd3879f03f21403aAa00045afeb31cb2(props: any) {
  const SecondaryNavigation = AppStore.presets["SecondaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} MemberPagesDd3879f03f21403aAa00045afeb31cb2 gf-page-layout`}>
      {props["header"] || <MembersAreaHeader90b86fff80d6439c9034054455b3a39f parentTag="Header95203a5cBe42476f8e9bEae728e4892c" {...props} />}
      {props["secondary-nav"] || <SecondaryNavigation className="SecondaryNav339ae8cfDc9f4668B920D15041925fcf" parentTag={buildClassName("SecondaryNav339ae8cfDc9f4668B920D15041925fcf", parentTag)} {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooter25b5a401E65a4c25886aDce4af827452 parentTag="Footer243def2d621b43d193e534316ad9abfe" {...props} />}
    </div>
  );
}

// id: "92fc428d-d61c-4f3d-a18d-393bb32c9fe5"
// title: "Marketing Cards Body"
// type: :html
// key: "marketing-body"
// parent_id: nil
export function MarketingBody92fc428dD61c4f3dA18d393bb32c9fe5(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} MarketingBody92fc428dD61c4f3dA18d393bb32c9fe5 page-body`}>
      {props["marketing-cards"] || <MarketingCards className="MarketingCardsE2bb597b38e244459a9eE2dcf0fb8adf" parentTag={buildClassName("MarketingCardsE2bb597b38e244459a9eE2dcf0fb8adf", parentTag)} {...props} />}
    </div>
  );
}

// id: "95203a5c-be42-476f-8e9b-eae728e4892c"
// title: ""
// type: :reference
// key: "header"
// parent_id: "dd3879f0-3f21-403a-aa00-045afeb31cb2"
export function Header95203a5cBe42476f8e9bEae728e4892c(props: any) {
  return (
    <MembersAreaHeader90b86fff80d6439c9034054455b3a39f parentTag="Header95203a5cBe42476f8e9bEae728e4892c" {...props} />
  );
}

// id: "243def2d-621b-43d1-93e5-34316ad9abfe"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "dd3879f0-3f21-403a-aa00-045afeb31cb2"
export function Footer243def2d621b43d193e534316ad9abfe(props: any) {
  return (
    <DefaultFooter25b5a401E65a4c25886aDce4af827452 parentTag="Footer243def2d621b43d193e534316ad9abfe" {...props} />
  );
}

// id: "ce60aaa7-eca5-4413-b407-88b90d11c72b"
// title: ""
// type: :gf_preset
// key: "welcome-back"
// parent_id: "7c267767-62b5-43d5-afb6-26575d0a5643"
export function WelcomeBackCe60aaa7Eca54413B40788b90d11c72b(props: any) {
  const WelcomeBackPopUp = AppStore.presets["WelcomeBackPopUp"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <WelcomeBackPopUp className="WelcomeBackCe60aaa7Eca54413B40788b90d11c72b" parentTag={buildClassName("WelcomeBackCe60aaa7Eca54413B40788b90d11c72b", parentTag)} {...props} />
  );
}

// id: "5cefc4bf-eab6-4655-abc0-43adcd21c17a"
// title: ""
// type: :reference
// key: "label"
// parent_id: "9e4b683c-014b-4da4-91d6-bb438460500d"
export function Label5cefc4bfEab64655Abc043adcd21c17a(props: any) {
  return (
    <DefaultLogo8024c0c42eeb463d9e1080e9743e8649 parentTag="Label5cefc4bfEab64655Abc043adcd21c17a" {...props} />
  );
}

// id: "86c498fc-2ea9-476f-a89f-7e61e29969ed"
// title: "Common Footer"
// type: :reference
// key: "footer"
// parent_id: nil
export function Footer86c498fc2ea9476fA89f7e61e29969ed(props: any) {
  return (
    <DefaultFooter25b5a401E65a4c25886aDce4af827452 parentTag="Footer86c498fc2ea9476fA89f7e61e29969ed" {...props} />
  );
}

// id: "f0ca1dc4-9f8b-4f0d-b64b-45824eb047fe"
// title: "Secondary Marketing Header Reference"
// type: :reference
// key: "header"
// parent_id: nil
export function HeaderF0ca1dc49f8b4f0dB64b45824eb047fe(props: any) {
  return (
    <SecondaryMarketingHeader6d22da4fD4dc471eB21e0f19910f28bd parentTag="HeaderF0ca1dc49f8b4f0dB64b45824eb047fe" {...props} />
  );
}

// id: "47b8a8bf-5acc-4d3e-b66f-0a6a410a058e"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "083a5a17-4423-498b-a547-8d1c92b1a39b"
export function Footer47b8a8bf5acc4d3eB66f0a6a410a058e(props: any) {
  return (
    <DefaultFooter25b5a401E65a4c25886aDce4af827452 parentTag="Footer47b8a8bf5acc4d3eB66f0a6a410a058e" {...props} />
  );
}

// id: "ef1989c6-df8f-40f2-b0a8-3ac18d026ffa"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "8ac4aff8-0a26-424e-9003-f896586e9d3a"
export function FooterEf1989c6Df8f40f2B0a83ac18d026ffa(props: any) {
  return (
    <DefaultFooter25b5a401E65a4c25886aDce4af827452 parentTag="FooterEf1989c6Df8f40f2B0a83ac18d026ffa" {...props} />
  );
}

// id: "7a5e3e81-65d0-4ace-ae51-4baadfaea45f"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "c93f454d-2b80-4e12-aebb-a1330028c898"
export const NavMenuSlug7a5e3e8165d04aceAe514baadfaea45f = "members-primary-nav";

// id: "1ef5bcc6-f3ec-41de-bc3c-8610d1bec5c7"
// title: "Header Area Top"
// type: :html
// key: "default-header-top"
// parent_id: nil
export function DefaultHeaderTop1ef5bcc6F3ec41deBc3c8610d1bec5c7(props: any) {
  const Link = AppStore.presets["Link"];
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} DefaultHeaderTop1ef5bcc6F3ec41deBc3c8610d1bec5c7 header-top`}>
      {props["linked-logo"] || <Link className="LinkedLogo9e4b683c014b4da491d6Bb438460500d" parentTag={buildClassName("LinkedLogo9e4b683c014b4da491d6Bb438460500d", parentTag)} label={<DefaultLogo8024c0c42eeb463d9e1080e9743e8649 parentTag="Label5cefc4bfEab64655Abc043adcd21c17a" alt="logo" />} url="/" className="linked-logo" {...props} />}
      {props["navigation"] || <PrimaryNavigation className="Navigation3653855aDf874b5cB1d8D2bf18b46ad9" parentTag={buildClassName("Navigation3653855aDf874b5cB1d8D2bf18b46ad9", parentTag)} navMenuSlug="marketing-primary-nav" className="navigation" {...props} />}
    </div>
  );
}

// id: "9a4d5465-04f0-4449-8a2a-821a291fae07"
// title: ""
// type: :gf_preset
// key: "groupflow"
// parent_id: "25b5a401-e65a-4c25-886a-dce4af827452"
export function Groupflow9a4d546504f044498a2a821a291fae07(props: any) {
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupFlowTag className="Groupflow9a4d546504f044498a2a821a291fae07" parentTag={buildClassName("Groupflow9a4d546504f044498a2a821a291fae07", parentTag)} {...props} />
  );
}

// id: "339ae8cf-dc9f-4668-b920-d15041925fcf"
// title: ""
// type: :gf_preset
// key: "secondary-nav"
// parent_id: "dd3879f0-3f21-403a-aa00-045afeb31cb2"
export function SecondaryNav339ae8cfDc9f4668B920D15041925fcf(props: any) {
  const SecondaryNavigation = AppStore.presets["SecondaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <SecondaryNavigation className="SecondaryNav339ae8cfDc9f4668B920D15041925fcf" parentTag={buildClassName("SecondaryNav339ae8cfDc9f4668B920D15041925fcf", parentTag)} {...props} />
  );
}

// id: "ba1bd02c-e23b-4b24-ab6b-43bc563f1a12"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "3653855a-df87-4b5c-b1d8-d2bf18b46ad9"
export const NavMenuSlugBa1bd02cE23b4b24Ab6b43bc563f1a12 = "marketing-primary-nav";

// id: "90b86fff-80d6-439c-9034-054455b3a39f"
// title: "Members Area Header"
// type: :reference
// key: "members-area-header"
// parent_id: nil
export function MembersAreaHeader90b86fff80d6439c9034054455b3a39f(props: any) {
  return (
    <ShortHeaderF599bc4983364fbf88ad8999fcb67518 parentTag="MembersAreaHeader90b86fff80d6439c9034054455b3a39f" header-top={<DefaultHeaderTop1ef5bcc6F3ec41deBc3c8610d1bec5c7 parentTag="HeaderTop08fd47fcFb374ee984beAb991592fb7f" navMenuSlug="members-primary-nav" />} {...props} />
  );
}

// id: "dee34917-3142-4a41-ad45-684a5d16f568"
// title: "Secondary Marketing Hero"
// type: :html
// key: "secondary-marketing-hero"
// parent_id: nil
export function SecondaryMarketingHeroDee3491731424a41Ad45684a5d16f568(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHeroDee3491731424a41Ad45684a5d16f568 hero`}>
      <div className="title">
        {props["title"] || Title0d06ac6390fb4994A919Ff63b417cc2a}
      </div>
    </div>
  );
}

// id: "5e89e9e8-eb6c-4278-b6b5-9b92b282d82f"
// title: ""
// type: :html
// key: "social-links"
// parent_id: "25b5a401-e65a-4c25-886a-dce4af827452"
export function SocialLinks5e89e9e8Eb6c4278B6b59b92b282d82f(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SocialLinks5e89e9e8Eb6c4278B6b59b92b282d82f flex flex-row justify-center gap-6 flex flex-row justify-center gap-6`}>
      <a className="hover:brightness-110" href="https://www.instagram.com/sexposla/">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" title="Instagram icon" className="fill-current" style={{width: "30px", height: "30px"}}>
          <path d="M18.5769 0C8.34616 0 0 8.34616 0 18.5769V45.4423C0 55.6538 8.34616 64 18.5769 64H45.4423C55.6538 64 64 55.6539 64 45.4231V18.5769C64 8.34616 55.6539 0 45.4231 0H18.5769ZM18.5769 4.92308H45.4231C53 4.92308 59.0769 11 59.0769 18.5769V45.4231C59.0769 53 53 59.0769 45.4423 59.0769H18.5769C11 59.0769 4.92308 53 4.92308 45.4423V18.5769C4.92308 11 11 4.92308 18.5769 4.92308ZM51.6923 9.84615C50.3269 9.84615 49.2308 10.9423 49.2308 12.3077C49.2308 13.6731 50.3269 14.7692 51.6923 14.7692C53.0577 14.7692 54.1538 13.6731 54.1538 12.3077C54.1538 10.9423 53.0577 9.84615 51.6923 9.84615ZM32 14.7692C22.5192 14.7692 14.7692 22.5192 14.7692 32C14.7692 41.4808 22.5192 49.2308 32 49.2308C41.4808 49.2308 49.2308 41.4808 49.2308 32C49.2308 22.5192 41.4808 14.7692 32 14.7692ZM32 19.6923C38.8269 19.6923 44.3077 25.1731 44.3077 32C44.3077 38.8269 38.8269 44.3077 32 44.3077C25.1731 44.3077 19.6923 38.8269 19.6923 32C19.6923 25.1731 25.1731 19.6923 32 19.6923Z" />
        </svg>
      </a>
      <a className="hover:brightness-110" href="https://www.facebook.com/groups/1104997742859454">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" title="Facebook icon" className="fill-current" style={{width: "30px", height: "30px"}}>
          <path d="M32 0C14.356 0 0 14.356 0 32C0 49.644 14.356 64 32 64C49.644 64 64 49.644 64 32C64 14.356 49.644 0 32 0ZM32 4.92308C46.9833 4.92308 59.0769 17.0167 59.0769 32C59.0769 45.6189 49.0711 56.8173 36 58.75V39.8269H43.6442L44.8462 32.0673H36V27.8173C36 24.5927 37.0495 21.7308 40.0673 21.7308H44.9135V14.9519C44.0618 14.8387 42.2625 14.5865 38.8558 14.5865C31.7468 14.5865 27.5769 18.3428 27.5769 26.8942V32.0577H20.2692V39.8269H27.5865V58.6827C14.719 56.5766 4.92308 45.4748 4.92308 32C4.92308 17.0167 17.0167 4.92308 32 4.92308Z" />
        </svg>
      </a>
      <a className="hover:brightness-110" href="https://twitter.com/sexposla">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" title="Twitter icon" className="fill-current" style={{width: "30px", height: "30px"}}>
          <path d="M8 0C3.61317 0 0 3.61317 0 8V56C0 60.3868 3.61317 64 8 64H56C60.3868 64 64 60.3868 64 56V8C64 3.61317 60.3868 0 56 0H8ZM8 5.33333H56C57.5012 5.33333 58.6667 6.49883 58.6667 8V56C58.6667 57.5012 57.5012 58.6667 56 58.6667H8C6.49883 58.6667 5.33333 57.5012 5.33333 56V8C5.33333 6.49883 6.49883 5.33333 8 5.33333ZM41.25 16C36.754 16 33.0988 19.6552 33.1042 24.1458C33.1042 24.9832 33.3958 25.5442 33.3958 26.1042C26.6545 25.8215 21.0557 22.4608 17.125 17.6875C16.2823 18.8128 16 20.2119 16 21.6146C16 24.4199 17.0931 26.6674 19.3438 28.6354C17.8504 28.4328 17.1253 28.0704 16 27.5104C16 31.4411 18.5029 34.527 22.1563 35.375C22.1563 35.375 20.7489 35.6563 19.9063 35.6563C19.2663 35.6563 18.5 35.375 18.5 35.375C19.6253 38.463 22.43 40.9896 26.0833 40.9896C23.278 42.9576 19.6221 44.3542 15.9688 44.3542H14C16.6667 46.6688 20.6635 48 26.3542 48C41.2395 48 49.3958 35.6563 49.3958 24.9896V23.8646C50.8038 22.7393 52.2027 21.3365 53.3333 19.6458C51.648 20.4938 50.2428 20.7694 48.5521 21.0521C50.2374 19.9321 51.6483 18.5252 52.2083 16.5625C50.8057 17.3998 49.1243 18.2382 47.1563 18.5208C45.7483 16.8408 43.5007 16 41.25 16Z" />
        </svg>
      </a>
      <a className="hover:brightness-110" href="https://www.sexpositivelosangeles.org/resources/discord">
        <svg width="64" height="71" viewBox="0 0 64 71" fill="none" xmlns="http://www.w3.org/2000/svg" title="Discord icon" className="fill-current" style={{width: "30px", height: "30px"}}>
          <path d="M7.11111 0C3.22467 0 0 3.19494 0 7.04555V56.3644C0 60.2127 3.22079 63.4062 7.10417 63.4099L48.6875 63.5063C49.2395 63.5064 49.784 63.3792 50.2778 63.1347L58.2014 69.506C58.7228 69.9259 59.3537 70.1908 60.0208 70.27C60.688 70.3493 61.3641 70.2396 61.971 69.9538C62.5778 69.6679 63.0905 69.2175 63.4496 68.6549C63.8087 68.0922 63.9995 67.4402 64 66.7745V7.04555C64 3.19494 60.7753 0 56.8889 0H7.11111ZM7.11111 7.04555H56.8889V59.3711L50.1667 53.97C49.6617 53.5648 49.0543 53.3044 48.4104 53.2172C47.7666 53.1299 47.1109 53.2191 46.5146 53.4752C45.9184 53.7312 45.4043 54.1442 45.0283 54.6693C44.6523 55.1945 44.4288 55.8117 44.3819 56.4538L7.11806 56.3644C7.11574 56.3644 7.11343 56.3644 7.11111 56.3644V7.04555ZM27.1528 18.1643C22.559 18.6011 19.0694 21.3224 19.0694 21.3224C19.0694 21.3224 14.9333 27.2306 14.2222 38.7712C18.4036 43.5058 24.7292 43.5324 24.7292 43.5324L26.0417 41.7985C24.7012 41.3406 23.5587 40.7531 22.3889 39.8583L22.6319 39.1427C24.8186 40.1326 27.6267 40.7114 32 40.7114C36.3733 40.7114 39.1814 40.1291 41.3681 39.1427L41.6111 39.8583C40.4378 40.7566 39.2952 41.3441 37.9583 41.7985L39.2708 43.5324C39.2708 43.5324 45.5964 43.5058 49.7778 38.7712C49.0667 27.2306 44.9306 21.3224 44.9306 21.3224C44.9306 21.3224 41.2277 18.4884 36.8472 18.1643L35.9444 19.9945C34.604 19.7514 33.2053 19.5748 32 19.5748C30.7556 19.5748 29.3572 19.7415 28.0417 19.967L27.1528 18.1643ZM25.5972 28.1822C27.1617 28.1822 28.4444 29.7604 28.4444 31.705C28.4444 33.6495 27.1617 35.2277 25.5972 35.2277C24.0328 35.2277 22.7569 33.6495 22.7569 31.705C22.7569 29.7604 24.0328 28.1822 25.5972 28.1822ZM38.4028 28.1822C39.9672 28.1822 41.2431 29.7604 41.2431 31.705C41.2431 33.6495 39.9672 35.2277 38.4028 35.2277C36.8383 35.2277 35.5556 33.6495 35.5556 31.705C35.5556 29.7604 36.8383 28.1822 38.4028 28.1822Z" />
        </svg>
      </a>
    </div>
  );
}

// id: "a7371969-7a46-46b1-8864-a6e4fa95056f"
// title: ""
// type: :gf_preset
// key: "hero"
// parent_id: "e381957f-fd39-45cd-a6d0-634e57ec798c"
export function HeroA73719697a4646b18864A6e4fa95056f(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Hero className="HeroA73719697a4646b18864A6e4fa95056f" parentTag={buildClassName("HeroA73719697a4646b18864A6e4fa95056f", parentTag)} postSlug="home-hero" {...props} />
  );
}

// id: "e2bb597b-38e2-4445-9a9e-e2dcf0fb8adf"
// title: "Marketing Cards"
// type: :gf_preset
// key: "marketing-cards"
// parent_id: "92fc428d-d61c-4f3d-a18d-393bb32c9fe5"
export function MarketingCardsE2bb597b38e244459a9eE2dcf0fb8adf(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="MarketingCardsE2bb597b38e244459a9eE2dcf0fb8adf" parentTag={buildClassName("MarketingCardsE2bb597b38e244459a9eE2dcf0fb8adf", parentTag)} {...props} />
  );
}

// id: "0cea909f-b34a-4751-bb17-84ad2ecb7ecd"
// title: ""
// type: :text
// key: "title"
// parent_id: "517d57ba-73c2-4585-b659-689dff2bdade"
export const Title0cea909fB34a4751Bb1784ad2ecb7ecd = "Secondary Page";

// id: "87067b3d-c786-4aaf-b66c-44797d6193df"
// title: "Password Reset Page"
// type: :reference
// key: "password-reset-page"
// parent_id: nil
export function PasswordResetPage87067b3dC7864aafB66c44797d6193df(props: any) {
  return (
    <LoginPageD342b899508447d9896aF6109019de60 parentTag="PasswordResetPage87067b3dC7864aafB66c44797d6193df" {...props} />
  );
}

// id: "5f4c8c28-0da6-4c12-84d0-d66e10680d8e"
// title: "Signup Pages"
// type: :reference
// key: "signup-pages"
// parent_id: nil
export function SignupPages5f4c8c280da64c1284d0D66e10680d8e(props: any) {
  return (
    <SecondaryPage083a5a174423498bA5478d1c92b1a39b parentTag="SignupPages5f4c8c280da64c1284d0D66e10680d8e" header={<SecondaryMarketingHeader6d22da4fD4dc471eB21e0f19910f28bd parentTag="HeaderD2ad43b9F0ee4db3B5ff7013d864d752" title="Join Us" />} {...props} />
  );
}

// id: "cbb3550d-a791-4464-975a-602f143a8921"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "f999e539-e9a8-48fe-92d8-537de632b12a"
export function FooterCbb3550dA7914464975a602f143a8921(props: any) {
  return (
    <DefaultFooter25b5a401E65a4c25886aDce4af827452 parentTag="FooterCbb3550dA7914464975a602f143a8921" {...props} />
  );
}

// id: "342d05e4-b74a-4433-a602-4f9c0028e676"
// title: ""
// type: :reference
// key: "header"
// parent_id: "f999e539-e9a8-48fe-92d8-537de632b12a"
export function Header342d05e4B74a4433A6024f9c0028e676(props: any) {
  return (
    <SecondaryMarketingHeader6d22da4fD4dc471eB21e0f19910f28bd parentTag="Header342d05e4B74a4433A6024f9c0028e676" title="Public Events" {...props} />
  );
}

// id: "2c369147-4691-412d-8a94-7ed65ea760c0"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "c8417464-9076-4ab7-aacb-2f696df9077a"
export const NavMenuSlug2c3691474691412d8a947ed65ea760c0 = "members-primary-nav";

// id: "a8df3b7d-9f5f-4429-823f-6a4ba2faa31a"
// title: "Home Page postSlug"
// type: :text
// key: "postSlug"
// parent_id: "3900bba6-1a9f-4d4f-a325-1b000f8e9389"
export const PostSlugA8df3b7d9f5f4429823f6a4ba2faa31a = "home-page-posts2";

// id: "083a5a17-4423-498b-a547-8d1c92b1a39b"
// title: "Secondary Page"
// type: :html
// key: "secondary-page"
// parent_id: nil
export function SecondaryPage083a5a174423498bA5478d1c92b1a39b(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryPage083a5a174423498bA5478d1c92b1a39b gf-page-layout`}>
      {props["header"] || <SecondaryMarketingHeader6d22da4fD4dc471eB21e0f19910f28bd parentTag="Header517d57ba73c24585B659689dff2bdade" title="Secondary Page" {...props} />}
      <div className="text-content">
        {props.children}
      </div>
      {props["footer"] || <DefaultFooter25b5a401E65a4c25886aDce4af827452 parentTag="Footer47b8a8bf5acc4d3eB66f0a6a410a058e" {...props} />}
    </div>
  );
}

// id: "b97b5b30-8945-4394-a19a-ae874d6c6257"
// title: "Page Quote"
// type: :html
// key: "page-quote"
// parent_id: nil
export function PageQuoteB97b5b3089454394A19aAe874d6c6257(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} PageQuoteB97b5b3089454394A19aAe874d6c6257`}>
      <div>
      </div>
      <div>
      </div>
    </div>
  );
}

// id: "194daa5a-6676-4701-9856-79b5e228fcc9"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "6d22da4f-d4dc-471e-b21e-0f19910f28bd"
export function HeaderTop194daa5a66764701985679b5e228fcc9(props: any) {
  return (
    <DefaultHeaderTop1ef5bcc6F3ec41deBc3c8610d1bec5c7 parentTag="HeaderTop194daa5a66764701985679b5e228fcc9" {...props} />
  );
}

// id: "53c10fe4-342f-47ed-8552-879a2b7d378e"
// title: "Login Footer"
// type: :reference
// key: "footer"
// parent_id: "d342b899-5084-47d9-896a-f6109019de60"
export function Footer53c10fe4342f47ed8552879a2b7d378e(props: any) {
  return (
    <DefaultFooter25b5a401E65a4c25886aDce4af827452 parentTag="Footer53c10fe4342f47ed8552879a2b7d378e" {...props} />
  );
}

// id: "59c0ab6a-f32c-4947-8c56-0a73eacf59d4"
// title: ""
// type: :text
// key: "class"
// parent_id: "3653855a-df87-4b5c-b1d8-d2bf18b46ad9"
export const Class59c0ab6aF32c49478c560a73eacf59d4 = "navigation";

// id: "702a46f0-9dd3-4bc6-b0da-2a2fdffcb34a"
// title: ""
// type: :reference
// key: "label"
// parent_id: "2eef6fa3-5f4b-4908-8968-d13f12e3d1b2"
export function Label702a46f09dd34bc6B0da2a2fdffcb34a(props: any) {
  return (
    <DefaultLogo8024c0c42eeb463d9e1080e9743e8649 parentTag="Label702a46f09dd34bc6B0da2a2fdffcb34a" {...props} />
  );
}

// id: "25b5a401-e65a-4c25-886a-dce4af827452"
// title: "Footer"
// type: :html
// key: "default-footer"
// parent_id: nil
export function DefaultFooter25b5a401E65a4c25886aDce4af827452(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <footer className={`${parentTag || ""} DefaultFooter25b5a401E65a4c25886aDce4af827452 footer`}>
      {props["social-links"] || <SocialLinksB4a1ea5d9a32404996c38c7ab61a157d />}
      {props["links"] || <Navigation className="Links66baa37364a34c07A3dbDaa5a3f4e9bb" parentTag={buildClassName("Links66baa37364a34c07A3dbDaa5a3f4e9bb", parentTag)} navMenuSlug="footer-nav" {...props} />}
      <div className="logo-wrapper">
        {props["logo"] || <LogoD5232a571c784d3b8e90621c85e9938b />}
      </div>
      {props["copyright"] || <GroupCopyright className="CopyrightE061694737714a759e33B61f6a63e14a" parentTag={buildClassName("CopyrightE061694737714a759e33B61f6a63e14a", parentTag)} {...props} />}
      {props["groupflow"] || <GroupFlowTag className="Groupflow9a4d546504f044498a2a821a291fae07" parentTag={buildClassName("Groupflow9a4d546504f044498a2a821a291fae07", parentTag)} {...props} />}
    </footer>
  );
}

// id: "7218b3e0-688a-46d4-a366-db928170574a"
// title: "Marketing Cards"
// type: :gf_preset
// key: "marketing-cards"
// parent_id: nil
export function MarketingCards7218b3e0688a46d4A366Db928170574a(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="MarketingCards7218b3e0688a46d4A366Db928170574a" parentTag={buildClassName("MarketingCards7218b3e0688a46d4A366Db928170574a", parentTag)} buttonClass="inline-block px-12 py-3 hover:brightness-110 transition duration" {...props} />
  );
}

// id: "9e4b683c-014b-4da4-91d6-bb438460500d"
// title: ""
// type: :gf_preset
// key: "linked-logo"
// parent_id: "1ef5bcc6-f3ec-41de-bc3c-8610d1bec5c7"
export function LinkedLogo9e4b683c014b4da491d6Bb438460500d(props: any) {
  const Link = AppStore.presets["Link"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Link className="LinkedLogo9e4b683c014b4da491d6Bb438460500d" parentTag={buildClassName("LinkedLogo9e4b683c014b4da491d6Bb438460500d", parentTag)} label={<DefaultLogo8024c0c42eeb463d9e1080e9743e8649 parentTag="Label5cefc4bfEab64655Abc043adcd21c17a" alt="logo" />} url="/" className="linked-logo" {...props} />
  );
}

// id: "a3b32a5c-1ab9-4b83-9bc5-0d122571ed17"
// title: ""
// type: :reference
// key: "hero"
// parent_id: "6d22da4f-d4dc-471e-b21e-0f19910f28bd"
export function HeroA3b32a5c1ab94b839bc50d122571ed17(props: any) {
  return (
    <SecondaryMarketingHeroDee3491731424a41Ad45684a5d16f568 parentTag="HeroA3b32a5c1ab94b839bc50d122571ed17" title="Secondary Marketing Title 2" {...props} />
  );
}

// id: "b7734085-5d61-4373-b79b-51faaec30dee"
// title: ""
// type: :text
// key: "label"
// parent_id: "1e537b3b-c27b-4227-bfaf-f2fc2babd6e9"
export const LabelB77340855d614373B79b51faaec30dee = "Join Us";

// id: "1d760e6e-8c39-48f0-a61c-31b0bb8acd2f"
// title: ""
// type: :text
// key: "href"
// parent_id: "1e537b3b-c27b-4227-bfaf-f2fc2babd6e9"
export const Href1d760e6e8c3948f0A61c31b0bb8acd2f = "/join";

// id: "f690f263-a736-4351-8253-9cebc7a00478"
// title: "Members Area"
// type: :html
// key: "members-area-default"
// parent_id: nil
export function MembersAreaDefaultF690f263A736435182539cebc7a00478(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} MembersAreaDefaultF690f263A736435182539cebc7a00478 page`}>
      {props["header"] || <MembersAreaHeader90b86fff80d6439c9034054455b3a39f parentTag="HeaderC93f454d2b804e12AebbA1330028c898" navMenuSlug="members-primary-nav" {...props} />}
      {props["footer"] || <DefaultFooter25b5a401E65a4c25886aDce4af827452 parentTag="Footer3013773d45a244859fa2C457edd48b6b" {...props} />}
    </div>
  );
}

// id: "e381957f-fd39-45cd-a6d0-634e57ec798c"
// title: "Home Header"
// type: :html
// key: "home-header"
// parent_id: nil
export function HomeHeaderE381957fFd3945cdA6d0634e57ec798c(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HomeHeaderE381957fFd3945cdA6d0634e57ec798c site-header`}>
      <div className="background-color" />
      <div className="background-image" />
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTop1ef5bcc6F3ec41deBc3c8610d1bec5c7 parentTag="HeaderTop85b62f963b3a4c25Beb27f1bdc66759f" {...props} />}
      </div>
      {props["hero"] || <Hero className="HeroA73719697a4646b18864A6e4fa95056f" parentTag={buildClassName("HeroA73719697a4646b18864A6e4fa95056f", parentTag)} postSlug="home-hero" {...props} />}
    </div>
  );
}

// id: "7e750485-500b-4b21-b593-f15da9fb3129"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "7c267767-62b5-43d5-afb6-26575d0a5643"
export function Footer7e750485500b4b21B593F15da9fb3129(props: any) {
  return (
    <DefaultFooter25b5a401E65a4c25886aDce4af827452 parentTag="Footer7e750485500b4b21B593F15da9fb3129" {...props} />
  );
}

// id: "9356fba6-c28e-4780-bc86-e53011560f9e"
// title: ""
// type: :text
// key: "buttonClass"
// parent_id: "7218b3e0-688a-46d4-a366-db928170574a"
export const ButtonClass9356fba6C28e4780Bc86E53011560f9e = "inline-block px-12 py-3 hover:brightness-110 transition duration";

// id: "98fd4fd6-527c-4350-8dc9-ab3c8a321549"
// title: ""
// type: :text
// key: "title"
// parent_id: "342d05e4-b74a-4433-a602-4f9c0028e676"
export const Title98fd4fd6527c43508dc9Ab3c8a321549 = "Public Events";

// id: "e674cbda-071d-4c4b-85cf-a06f6ec3af19"
// title: "Admin Pages"
// type: :html
// key: "admin-pages"
// parent_id: nil
export function AdminPagesE674cbda071d4c4b85cfA06f6ec3af19(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AdminPagesE674cbda071d4c4b85cfA06f6ec3af19 gf-page-layout`}>
      {props.children}
    </div>
  );
}

// id: "77e6c1cf-fbd1-485a-b044-20f508269353"
// title: "Join Us Page"
// type: :reference
// key: "join-us-page"
// parent_id: nil
export function JoinUsPage77e6c1cfFbd1485aB04420f508269353(props: any) {
  return (
    <SecondaryPage083a5a174423498bA5478d1c92b1a39b parentTag="JoinUsPage77e6c1cfFbd1485aB04420f508269353" header={<SecondaryMarketingHeader6d22da4fD4dc471eB21e0f19910f28bd parentTag="Header7b527641531b4e368315De2e2a0e2db0" title="Join Us" />} {...props} />
  );
}

// id: "66baa373-64a3-4c07-a3db-daa5a3f4e9bb"
// title: ""
// type: :gf_preset
// key: "links"
// parent_id: "25b5a401-e65a-4c25-886a-dce4af827452"
export function Links66baa37364a34c07A3dbDaa5a3f4e9bb(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Navigation className="Links66baa37364a34c07A3dbDaa5a3f4e9bb" parentTag={buildClassName("Links66baa37364a34c07A3dbDaa5a3f4e9bb", parentTag)} navMenuSlug="footer-nav" {...props} />
  );
}

// id: "08fd47fc-fb37-4ee9-84be-ab991592fb7f"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "90b86fff-80d6-439c-9034-054455b3a39f"
export function HeaderTop08fd47fcFb374ee984beAb991592fb7f(props: any) {
  return (
    <DefaultHeaderTop1ef5bcc6F3ec41deBc3c8610d1bec5c7 parentTag="HeaderTop08fd47fcFb374ee984beAb991592fb7f" navMenuSlug="members-primary-nav" {...props} />
  );
}

// id: "ab7bba6d-e659-49be-8288-190acf27d88f"
// title: ""
// type: :text
// key: "url"
// parent_id: "9e4b683c-014b-4da4-91d6-bb438460500d"
export const UrlAb7bba6dE65949be8288190acf27d88f = "/";

// id: "4031dff9-c8db-4cb4-a926-3add7f96537f"
// title: "HREF"
// type: :text
// key: "href"
// parent_id: nil
export const Href4031dff9C8db4cb4A9263add7f96537f = "/";

// id: "322f2d2f-489b-4087-a094-005114177d63"
// title: "Home Page Hero"
// type: :html
// key: "home-page-hero"
// parent_id: nil
export function HomePageHero322f2d2f489b4087A094005114177d63(props: any) {
  const Button = AppStore.presets["Button"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HomePageHero322f2d2f489b4087A094005114177d63 hero`}>
      <div className="title">
        Learn. Play. Grow.
      </div>
      <div className="body">
        Our mission is to change the world by promoting healthy sexuality through community and education.
      </div>
      <div className="button">
        {props["button"] || <Button className="Button1e537b3bC27b4227BfafF2fc2babd6e9" parentTag={buildClassName("Button1e537b3bC27b4227BfafF2fc2babd6e9", parentTag)} label="Join Us" href="/join" {...props} />}
      </div>
    </div>
  );
}

// id: "13834b22-c7b7-4385-aeb1-a409ca189827"
// title: ""
// type: :text
// key: "backgroundImage"
// parent_id: "f599bc49-8336-4fbf-88ad-8999fcb67518"
export const BackgroundImage13834b22C7b74385Aeb1A409ca189827 = "https://mp1md-pub.s3.amazonaws.com/spla/images/spla-skyline.jpeg";

// id: "e0616947-3771-4a75-9e33-b61f6a63e14a"
// title: ""
// type: :gf_preset
// key: "copyright"
// parent_id: "25b5a401-e65a-4c25-886a-dce4af827452"
export function CopyrightE061694737714a759e33B61f6a63e14a(props: any) {
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupCopyright className="CopyrightE061694737714a759e33B61f6a63e14a" parentTag={buildClassName("CopyrightE061694737714a759e33B61f6a63e14a", parentTag)} {...props} />
  );
}

// id: "97de754c-da07-4bae-8657-1d7543cbaad4"
// title: "Login Page Title"
// type: :text
// key: "title"
// parent_id: "32c1b2db-50d3-4558-b557-65b1cac456cd"
export const Title97de754cDa074bae86571d7543cbaad4 = "Login";

// id: "f599bc49-8336-4fbf-88ad-8999fcb67518"
// title: "Short Header"
// type: :html
// key: "short-header"
// parent_id: nil
export function ShortHeaderF599bc4983364fbf88ad8999fcb67518(props: any) {
  const Link = AppStore.presets["Link"];
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} ShortHeaderF599bc4983364fbf88ad8999fcb67518 site-header`}>
      <div className="background-image" />
      <div className="header-top">
        {props["linked-logo"] || <Link className="LinkedLogo2eef6fa35f4b49088968D13f12e3d1b2" parentTag={buildClassName("LinkedLogo2eef6fa35f4b49088968D13f12e3d1b2", parentTag)} label={<DefaultLogo8024c0c42eeb463d9e1080e9743e8649 parentTag="Label702a46f09dd34bc6B0da2a2fdffcb34a" alt="logo" />} {...props} />}
        {props["navigation"] || <PrimaryNavigation className="NavigationC841746490764ab7Aacb2f696df9077a" parentTag={buildClassName("NavigationC841746490764ab7Aacb2f696df9077a", parentTag)} navMenuSlug="members-primary-nav" {...props} />}
      </div>
    </div>
  );
}

// id: "7c267767-62b5-43d5-afb6-26575d0a5643"
// title: "Home Page"
// type: :html
// key: "home-page"
// parent_id: nil
export function HomePage7c26776762b543d5Afb626575d0a5643(props: any) {
  const WelcomeBackPopUp = AppStore.presets["WelcomeBackPopUp"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HomePage7c26776762b543d5Afb626575d0a5643 page gf-page-layout page gf-page-layout`}>
      {props["header"] || <HomeHeaderE381957fFd3945cdA6d0634e57ec798c parentTag="Header9025786813464eddBa754df5b4074c05" {...props} />}
      {props["welcome-back"] || <WelcomeBackPopUp className="WelcomeBackCe60aaa7Eca54413B40788b90d11c72b" parentTag={buildClassName("WelcomeBackCe60aaa7Eca54413B40788b90d11c72b", parentTag)} {...props} />}
      {props["body"] || <MarketingBody92fc428dD61c4f3dA18d393bb32c9fe5 parentTag="Body3900bba61a9f4d4fA3251b000f8e9389" postSlug="home-page-posts2" {...props} />}
      {props["quote"] || <QuoteFa612e8c7939417b890a1bb64fc9f5a3 />}
      {props["footer"] || <DefaultFooter25b5a401E65a4c25886aDce4af827452 parentTag="Footer7e750485500b4b21B593F15da9fb3129" {...props} />}
    </div>
  );
}

// id: "10988306-0ebf-42c5-b355-0600028af36d"
// title: ""
// type: :reference
// key: "header"
// parent_id: "c1007033-e4ac-4a29-8d6b-acd4a49458dd"
export function Header109883060ebf42c5B3550600028af36d(props: any) {
  return (
    <SecondaryMarketingHeader6d22da4fD4dc471eB21e0f19910f28bd parentTag="Header109883060ebf42c5B3550600028af36d" title="Resources" {...props} />
  );
}

// id: "90257868-1346-4edd-ba75-4df5b4074c05"
// title: ""
// type: :reference
// key: "header"
// parent_id: "7c267767-62b5-43d5-afb6-26575d0a5643"
export function Header9025786813464eddBa754df5b4074c05(props: any) {
  return (
    <HomeHeaderE381957fFd3945cdA6d0634e57ec798c parentTag="Header9025786813464eddBa754df5b4074c05" {...props} />
  );
}

// id: "f11d7083-702a-4645-9b93-f229c5e7a0ac"
// title: ""
// type: :text
// key: "title"
// parent_id: "75da0fb9-feef-41f4-938e-f6042ba9089b"
export const TitleF11d7083702a46459b93F229c5e7a0ac = "About Us";

// id: "8ac4aff8-0a26-424e-9003-f896586e9d3a"
// title: "About Us"
// type: :html
// key: "about-us-page"
// parent_id: nil
export function AboutUsPage8ac4aff80a26424e9003F896586e9d3a(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AboutUsPage8ac4aff80a26424e9003F896586e9d3a page gf-page-layout page gf-page-layout`}>
      {props["header"] || <SecondaryMarketingHeader6d22da4fD4dc471eB21e0f19910f28bd parentTag="Header75da0fb9Feef41f4938eF6042ba9089b" title="About Us" {...props} />}
      {props["body"] || <MarketingBody92fc428dD61c4f3dA18d393bb32c9fe5 parentTag="BodyBe1bb880100f4579Ba5fEf4123928a7c" postSlug="about-page-posts" {...props} />}
      {props["footer"] || <DefaultFooter25b5a401E65a4c25886aDce4af827452 parentTag="FooterEf1989c6Df8f40f2B0a83ac18d026ffa" {...props} />}
    </div>
  );
}

// id: "86785c3f-3c71-44e1-b7f4-2cbfd3473d77"
// title: "Message Pages"
// type: :html
// key: "message-pages"
// parent_id: nil
export function MessagePages86785c3f3c7144e1B7f42cbfd3473d77(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} MessagePages86785c3f3c7144e1B7f42cbfd3473d77 gf-page-layout`}>
      {props["header"] || <MembersAreaHeader90b86fff80d6439c9034054455b3a39f parentTag="Header775c98d05d5f417b9d7f730a295925b1" {...props} />}
      {props.children}
    </div>
  );
}

// id: "425cd515-3f7a-4602-81c4-a39846d991af"
// title: ""
// type: :html
// key: "social-links"
// parent_id: "25b5a401-e65a-4c25-886a-dce4af827452"
export function SocialLinks425cd5153f7a460281c4A39846d991af(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SocialLinks425cd5153f7a460281c4A39846d991af flex flex-row justify-center gap-6 flex flex-row justify-center gap-6`}>
      <a className="hover:brightness-110" href="https://www.instagram.com/sexposla/">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" title="Instagram icon" className="fill-current" style={{width: "30px", height: "30px"}}>
          <path d="M18.5769 0C8.34616 0 0 8.34616 0 18.5769V45.4423C0 55.6538 8.34616 64 18.5769 64H45.4423C55.6538 64 64 55.6539 64 45.4231V18.5769C64 8.34616 55.6539 0 45.4231 0H18.5769ZM18.5769 4.92308H45.4231C53 4.92308 59.0769 11 59.0769 18.5769V45.4231C59.0769 53 53 59.0769 45.4423 59.0769H18.5769C11 59.0769 4.92308 53 4.92308 45.4423V18.5769C4.92308 11 11 4.92308 18.5769 4.92308ZM51.6923 9.84615C50.3269 9.84615 49.2308 10.9423 49.2308 12.3077C49.2308 13.6731 50.3269 14.7692 51.6923 14.7692C53.0577 14.7692 54.1538 13.6731 54.1538 12.3077C54.1538 10.9423 53.0577 9.84615 51.6923 9.84615ZM32 14.7692C22.5192 14.7692 14.7692 22.5192 14.7692 32C14.7692 41.4808 22.5192 49.2308 32 49.2308C41.4808 49.2308 49.2308 41.4808 49.2308 32C49.2308 22.5192 41.4808 14.7692 32 14.7692ZM32 19.6923C38.8269 19.6923 44.3077 25.1731 44.3077 32C44.3077 38.8269 38.8269 44.3077 32 44.3077C25.1731 44.3077 19.6923 38.8269 19.6923 32C19.6923 25.1731 25.1731 19.6923 32 19.6923Z" />
        </svg>
      </a>
      <a className="hover:brightness-110" href="https://www.facebook.com/groups/1104997742859454">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" title="Facebook icon" className="fill-current" style={{width: "30px", height: "30px"}}>
          <path d="M32 0C14.356 0 0 14.356 0 32C0 49.644 14.356 64 32 64C49.644 64 64 49.644 64 32C64 14.356 49.644 0 32 0ZM32 4.92308C46.9833 4.92308 59.0769 17.0167 59.0769 32C59.0769 45.6189 49.0711 56.8173 36 58.75V39.8269H43.6442L44.8462 32.0673H36V27.8173C36 24.5927 37.0495 21.7308 40.0673 21.7308H44.9135V14.9519C44.0618 14.8387 42.2625 14.5865 38.8558 14.5865C31.7468 14.5865 27.5769 18.3428 27.5769 26.8942V32.0577H20.2692V39.8269H27.5865V58.6827C14.719 56.5766 4.92308 45.4748 4.92308 32C4.92308 17.0167 17.0167 4.92308 32 4.92308Z" />
        </svg>
      </a>
      <a className="hover:brightness-110" href="https://twitter.com/sexposla">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" title="Twitter icon" className="fill-current" style={{width: "30px", height: "30px"}}>
          <path d="M8 0C3.61317 0 0 3.61317 0 8V56C0 60.3868 3.61317 64 8 64H56C60.3868 64 64 60.3868 64 56V8C64 3.61317 60.3868 0 56 0H8ZM8 5.33333H56C57.5012 5.33333 58.6667 6.49883 58.6667 8V56C58.6667 57.5012 57.5012 58.6667 56 58.6667H8C6.49883 58.6667 5.33333 57.5012 5.33333 56V8C5.33333 6.49883 6.49883 5.33333 8 5.33333ZM41.25 16C36.754 16 33.0988 19.6552 33.1042 24.1458C33.1042 24.9832 33.3958 25.5442 33.3958 26.1042C26.6545 25.8215 21.0557 22.4608 17.125 17.6875C16.2823 18.8128 16 20.2119 16 21.6146C16 24.4199 17.0931 26.6674 19.3438 28.6354C17.8504 28.4328 17.1253 28.0704 16 27.5104C16 31.4411 18.5029 34.527 22.1563 35.375C22.1563 35.375 20.7489 35.6563 19.9063 35.6563C19.2663 35.6563 18.5 35.375 18.5 35.375C19.6253 38.463 22.43 40.9896 26.0833 40.9896C23.278 42.9576 19.6221 44.3542 15.9688 44.3542H14C16.6667 46.6688 20.6635 48 26.3542 48C41.2395 48 49.3958 35.6563 49.3958 24.9896V23.8646C50.8038 22.7393 52.2027 21.3365 53.3333 19.6458C51.648 20.4938 50.2428 20.7694 48.5521 21.0521C50.2374 19.9321 51.6483 18.5252 52.2083 16.5625C50.8057 17.3998 49.1243 18.2382 47.1563 18.5208C45.7483 16.8408 43.5007 16 41.25 16Z" />
        </svg>
      </a>
      <a className="hover:brightness-110" href="https://www.sexpositivelosangeles.org/resources/discord">
        <svg width="64" height="71" viewBox="0 0 64 71" fill="none" xmlns="http://www.w3.org/2000/svg" title="Discord icon" className="fill-current" style={{width: "30px", height: "30px"}}>
          <path d="M7.11111 0C3.22467 0 0 3.19494 0 7.04555V56.3644C0 60.2127 3.22079 63.4062 7.10417 63.4099L48.6875 63.5063C49.2395 63.5064 49.784 63.3792 50.2778 63.1347L58.2014 69.506C58.7228 69.9259 59.3537 70.1908 60.0208 70.27C60.688 70.3493 61.3641 70.2396 61.971 69.9538C62.5778 69.6679 63.0905 69.2175 63.4496 68.6549C63.8087 68.0922 63.9995 67.4402 64 66.7745V7.04555C64 3.19494 60.7753 0 56.8889 0H7.11111ZM7.11111 7.04555H56.8889V59.3711L50.1667 53.97C49.6617 53.5648 49.0543 53.3044 48.4104 53.2172C47.7666 53.1299 47.1109 53.2191 46.5146 53.4752C45.9184 53.7312 45.4043 54.1442 45.0283 54.6693C44.6523 55.1945 44.4288 55.8117 44.3819 56.4538L7.11806 56.3644C7.11574 56.3644 7.11343 56.3644 7.11111 56.3644V7.04555ZM27.1528 18.1643C22.559 18.6011 19.0694 21.3224 19.0694 21.3224C19.0694 21.3224 14.9333 27.2306 14.2222 38.7712C18.4036 43.5058 24.7292 43.5324 24.7292 43.5324L26.0417 41.7985C24.7012 41.3406 23.5587 40.7531 22.3889 39.8583L22.6319 39.1427C24.8186 40.1326 27.6267 40.7114 32 40.7114C36.3733 40.7114 39.1814 40.1291 41.3681 39.1427L41.6111 39.8583C40.4378 40.7566 39.2952 41.3441 37.9583 41.7985L39.2708 43.5324C39.2708 43.5324 45.5964 43.5058 49.7778 38.7712C49.0667 27.2306 44.9306 21.3224 44.9306 21.3224C44.9306 21.3224 41.2277 18.4884 36.8472 18.1643L35.9444 19.9945C34.604 19.7514 33.2053 19.5748 32 19.5748C30.7556 19.5748 29.3572 19.7415 28.0417 19.967L27.1528 18.1643ZM25.5972 28.1822C27.1617 28.1822 28.4444 29.7604 28.4444 31.705C28.4444 33.6495 27.1617 35.2277 25.5972 35.2277C24.0328 35.2277 22.7569 33.6495 22.7569 31.705C22.7569 29.7604 24.0328 28.1822 25.5972 28.1822ZM38.4028 28.1822C39.9672 28.1822 41.2431 29.7604 41.2431 31.705C41.2431 33.6495 39.9672 35.2277 38.4028 35.2277C36.8383 35.2277 35.5556 33.6495 35.5556 31.705C35.5556 29.7604 36.8383 28.1822 38.4028 28.1822Z" />
        </svg>
      </a>
    </div>
  );
}

// id: "be1bb880-100f-4579-ba5f-ef4123928a7c"
// title: ""
// type: :reference
// key: "body"
// parent_id: "8ac4aff8-0a26-424e-9003-f896586e9d3a"
export function BodyBe1bb880100f4579Ba5fEf4123928a7c(props: any) {
  return (
    <MarketingBody92fc428dD61c4f3dA18d393bb32c9fe5 parentTag="BodyBe1bb880100f4579Ba5fEf4123928a7c" postSlug="about-page-posts" {...props} />
  );
}

// id: "e495b5d5-db1f-4408-93ad-9cc4df489e4d"
// title: ""
// type: :text
// key: "title"
// parent_id: "d2ad43b9-f0ee-4db3-b5ff-7013d864d752"
export const TitleE495b5d5Db1f440893ad9cc4df489e4d = "Join Us";

// id: "d9e6b5cb-476f-4648-b97d-1ea6e209b31b"
// title: "Members Header"
// type: :reference
// key: "header"
// parent_id: nil
export function HeaderD9e6b5cb476f4648B97d1ea6e209b31b(props: any) {
  return (
    <MembersAreaHeader90b86fff80d6439c9034054455b3a39f parentTag="HeaderD9e6b5cb476f4648B97d1ea6e209b31b" {...props} />
  );
}

// id: "f999e539-e9a8-48fe-92d8-537de632b12a"
// title: "Public Events Page"
// type: :html
// key: "public-events-page"
// parent_id: nil
export function PublicEventsPageF999e539E9a848fe92d8537de632b12a(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} PublicEventsPageF999e539E9a848fe92d8537de632b12a gf-page-layout`}>
      {props["header"] || <SecondaryMarketingHeader6d22da4fD4dc471eB21e0f19910f28bd parentTag="Header342d05e4B74a4433A6024f9c0028e676" title="Public Events" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooter25b5a401E65a4c25886aDce4af827452 parentTag="FooterCbb3550dA7914464975a602f143a8921" {...props} />}
    </div>
  );
}

// id: "32c1b2db-50d3-4558-b557-65b1cac456cd"
// title: "Login Header"
// type: :reference
// key: "header"
// parent_id: "d342b899-5084-47d9-896a-f6109019de60"
export function Header32c1b2db50d34558B55765b1cac456cd(props: any) {
  return (
    <SecondaryMarketingHeader6d22da4fD4dc471eB21e0f19910f28bd parentTag="Header32c1b2db50d34558B55765b1cac456cd" title="Login" {...props} />
  );
}

// id: "946c97a5-5e88-4331-9198-da16e9d9071b"
// title: "Public Primary Navigation"
// type: :text
// key: "navMenuSlug"
// parent_id: "09249255-62b3-4385-83c8-09987930342c"
export const NavMenuSlug946c97a55e8843319198Da16e9d9071b = "marketing-primary-nav";

// id: "fb3c29a9-d7ab-499c-85da-de1361244f52"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "a7371969-7a46-46b1-8864-a6e4fa95056f"
export const PostSlugFb3c29a9D7ab499c85daDe1361244f52 = "home-hero";

// id: "09249255-62b3-4385-83c8-09987930342c"
// title: "Default Header Reference"
// type: :reference
// key: "default-header"
// parent_id: nil
export function DefaultHeader0924925562b3438583c809987930342c(props: any) {
  return (
    <ShortHeaderF599bc4983364fbf88ad8999fcb67518 parentTag="DefaultHeader0924925562b3438583c809987930342c" navMenuSlug="marketing-primary-nav" title {...props} />
  );
}

// id: "c8417464-9076-4ab7-aacb-2f696df9077a"
// title: ""
// type: :gf_preset
// key: "navigation"
// parent_id: "f599bc49-8336-4fbf-88ad-8999fcb67518"
export function NavigationC841746490764ab7Aacb2f696df9077a(props: any) {
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PrimaryNavigation className="NavigationC841746490764ab7Aacb2f696df9077a" parentTag={buildClassName("NavigationC841746490764ab7Aacb2f696df9077a", parentTag)} navMenuSlug="members-primary-nav" {...props} />
  );
}

// id: "2eef6fa3-5f4b-4908-8968-d13f12e3d1b2"
// title: ""
// type: :gf_preset
// key: "linked-logo"
// parent_id: "f599bc49-8336-4fbf-88ad-8999fcb67518"
export function LinkedLogo2eef6fa35f4b49088968D13f12e3d1b2(props: any) {
  const Link = AppStore.presets["Link"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Link className="LinkedLogo2eef6fa35f4b49088968D13f12e3d1b2" parentTag={buildClassName("LinkedLogo2eef6fa35f4b49088968D13f12e3d1b2", parentTag)} label={<DefaultLogo8024c0c42eeb463d9e1080e9743e8649 parentTag="Label702a46f09dd34bc6B0da2a2fdffcb34a" alt="logo" />} {...props} />
  );
}

// id: "c93f454d-2b80-4e12-aebb-a1330028c898"
// title: ""
// type: :reference
// key: "header"
// parent_id: "f690f263-a736-4351-8253-9cebc7a00478"
export function HeaderC93f454d2b804e12AebbA1330028c898(props: any) {
  return (
    <MembersAreaHeader90b86fff80d6439c9034054455b3a39f parentTag="HeaderC93f454d2b804e12AebbA1330028c898" navMenuSlug="members-primary-nav" {...props} />
  );
}

// id: "0d1071fe-6478-4d12-8010-7b53abb05edf"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "08fd47fc-fb37-4ee9-84be-ab991592fb7f"
export const NavMenuSlug0d1071fe64784d1280107b53abb05edf = "members-primary-nav";

// id: "c1007033-e4ac-4a29-8d6b-acd4a49458dd"
// title: "Resources Page"
// type: :reference
// key: "resources-page"
// parent_id: nil
export function ResourcesPageC1007033E4ac4a298d6bAcd4a49458dd(props: any) {
  return (
    <SecondaryPage083a5a174423498bA5478d1c92b1a39b parentTag="ResourcesPageC1007033E4ac4a298d6bAcd4a49458dd" header={<SecondaryMarketingHeader6d22da4fD4dc471eB21e0f19910f28bd parentTag="Header109883060ebf42c5B3550600028af36d" title="Resources" />} {...props} />
  );
}

// id: "1e537b3b-c27b-4227-bfaf-f2fc2babd6e9"
// title: ""
// type: :gf_preset
// key: "button"
// parent_id: "322f2d2f-489b-4087-a094-005114177d63"
export function Button1e537b3bC27b4227BfafF2fc2babd6e9(props: any) {
  const Button = AppStore.presets["Button"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Button className="Button1e537b3bC27b4227BfafF2fc2babd6e9" parentTag={buildClassName("Button1e537b3bC27b4227BfafF2fc2babd6e9", parentTag)} label="Join Us" href="/join" {...props} />
  );
}

// id: "21508ae4-abd3-47eb-a4a8-4c7fed005683"
// title: ""
// type: :text
// key: "title"
// parent_id: "6d22da4f-d4dc-471e-b21e-0f19910f28bd"
export const Title21508ae4Abd347ebA4a84c7fed005683 = "Secondary Marketing Title 1";

// id: "23c11ec6-51d2-461e-bca4-7a77081bb643"
// title: ""
// type: :text
// key: "title"
// parent_id: "10988306-0ebf-42c5-b355-0600028af36d"
export const Title23c11ec651d2461eBca47a77081bb643 = "Resources";

// id: "85295424-4e75-4547-a498-e1e65c58be45"
// title: "Label"
// type: :reference
// key: "label"
// parent_id: nil
export function Label852954244e754547A498E1e65c58be45(props: any) {
  return (
    <DefaultLogo8024c0c42eeb463d9e1080e9743e8649 parentTag="Label852954244e754547A498E1e65c58be45" {...props} />
  );
}

// id: "85fb6518-9809-4fcf-9e5c-373537b80d8d"
// title: ""
// type: :text
// key: "alt"
// parent_id: "8024c0c4-2eeb-463d-9e10-80e9743e8649"
export const Alt85fb651898094fcf9e5c373537b80d8d = "logo";

// id: "3013773d-45a2-4485-9fa2-c457edd48b6b"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "f690f263-a736-4351-8253-9cebc7a00478"
export function Footer3013773d45a244859fa2C457edd48b6b(props: any) {
  return (
    <DefaultFooter25b5a401E65a4c25886aDce4af827452 parentTag="Footer3013773d45a244859fa2C457edd48b6b" {...props} />
  );
}

// id: "fa612e8c-7939-417b-890a-1bb64fc9f5a3"
// title: ""
// type: :html
// key: "quote"
// parent_id: "7c267767-62b5-43d5-afb6-26575d0a5643"
export function QuoteFa612e8c7939417b890a1bb64fc9f5a3(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} QuoteFa612e8c7939417b890a1bb64fc9f5a3 PageQuote`}>
      <img src="https://mp1md-pub.s3-us-west-2.amazonaws.com/content/fDIDlI3qk75Cn3iS_regular.jpeg" className="image opacity" />
      <div className="TextContent">
        Our mission is to change the world by promoting healthy sexuality through community and education.
      </div>
    </div>
  );
}

// id: "2e693d72-62ae-4cf0-b5a0-7b1473872051"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "66baa373-64a3-4c07-a3db-daa5a3f4e9bb"
export const NavMenuSlug2e693d7262ae4cf0B5a07b1473872051 = "footer-nav";

// id: "d342b899-5084-47d9-896a-f6109019de60"
// title: "Login Page"
// type: :html
// key: "login-page"
// parent_id: nil
export function LoginPageD342b899508447d9896aF6109019de60(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <>
      {props["header"] || <SecondaryMarketingHeader6d22da4fD4dc471eB21e0f19910f28bd parentTag="Header32c1b2db50d34558B55765b1cac456cd" title="Login" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooter25b5a401E65a4c25886aDce4af827452 parentTag="Footer53c10fe4342f47ed8552879a2b7d378e" {...props} />}
    </>
  );
}

// id: "3653855a-df87-4b5c-b1d8-d2bf18b46ad9"
// title: ""
// type: :gf_preset
// key: "navigation"
// parent_id: "1ef5bcc6-f3ec-41de-bc3c-8610d1bec5c7"
export function Navigation3653855aDf874b5cB1d8D2bf18b46ad9(props: any) {
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PrimaryNavigation className="Navigation3653855aDf874b5cB1d8D2bf18b46ad9" parentTag={buildClassName("Navigation3653855aDf874b5cB1d8D2bf18b46ad9", parentTag)} navMenuSlug="marketing-primary-nav" className="navigation" {...props} />
  );
}

// id: "b4a1ea5d-9a32-4049-96c3-8c7ab61a157d"
// title: ""
// type: :html
// key: "social-links"
// parent_id: "25b5a401-e65a-4c25-886a-dce4af827452"
export function SocialLinksB4a1ea5d9a32404996c38c7ab61a157d(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SocialLinksB4a1ea5d9a32404996c38c7ab61a157d flex flex-row justify-center gap-6 flex flex-row justify-center gap-6`}>
      <a className="hover:brightness-110" href="https://www.instagram.com/sexposla/">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" title="Instagram icon" className="fill-current" style={{width: "30px", height: "30px"}}>
          <path d="M18.5769 0C8.34616 0 0 8.34616 0 18.5769V45.4423C0 55.6538 8.34616 64 18.5769 64H45.4423C55.6538 64 64 55.6539 64 45.4231V18.5769C64 8.34616 55.6539 0 45.4231 0H18.5769ZM18.5769 4.92308H45.4231C53 4.92308 59.0769 11 59.0769 18.5769V45.4231C59.0769 53 53 59.0769 45.4423 59.0769H18.5769C11 59.0769 4.92308 53 4.92308 45.4423V18.5769C4.92308 11 11 4.92308 18.5769 4.92308ZM51.6923 9.84615C50.3269 9.84615 49.2308 10.9423 49.2308 12.3077C49.2308 13.6731 50.3269 14.7692 51.6923 14.7692C53.0577 14.7692 54.1538 13.6731 54.1538 12.3077C54.1538 10.9423 53.0577 9.84615 51.6923 9.84615ZM32 14.7692C22.5192 14.7692 14.7692 22.5192 14.7692 32C14.7692 41.4808 22.5192 49.2308 32 49.2308C41.4808 49.2308 49.2308 41.4808 49.2308 32C49.2308 22.5192 41.4808 14.7692 32 14.7692ZM32 19.6923C38.8269 19.6923 44.3077 25.1731 44.3077 32C44.3077 38.8269 38.8269 44.3077 32 44.3077C25.1731 44.3077 19.6923 38.8269 19.6923 32C19.6923 25.1731 25.1731 19.6923 32 19.6923Z" />
        </svg>
      </a>
      <a className="hover:brightness-110" href="https://www.facebook.com/groups/1104997742859454">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" title="Facebook icon" className="fill-current" style={{width: "30px", height: "30px"}}>
          <path d="M32 0C14.356 0 0 14.356 0 32C0 49.644 14.356 64 32 64C49.644 64 64 49.644 64 32C64 14.356 49.644 0 32 0ZM32 4.92308C46.9833 4.92308 59.0769 17.0167 59.0769 32C59.0769 45.6189 49.0711 56.8173 36 58.75V39.8269H43.6442L44.8462 32.0673H36V27.8173C36 24.5927 37.0495 21.7308 40.0673 21.7308H44.9135V14.9519C44.0618 14.8387 42.2625 14.5865 38.8558 14.5865C31.7468 14.5865 27.5769 18.3428 27.5769 26.8942V32.0577H20.2692V39.8269H27.5865V58.6827C14.719 56.5766 4.92308 45.4748 4.92308 32C4.92308 17.0167 17.0167 4.92308 32 4.92308Z" />
        </svg>
      </a>
      <a className="hover:brightness-110" href="https://twitter.com/sexposla">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" title="Twitter icon" className="fill-current" style={{width: "30px", height: "30px"}}>
          <path d="M8 0C3.61317 0 0 3.61317 0 8V56C0 60.3868 3.61317 64 8 64H56C60.3868 64 64 60.3868 64 56V8C64 3.61317 60.3868 0 56 0H8ZM8 5.33333H56C57.5012 5.33333 58.6667 6.49883 58.6667 8V56C58.6667 57.5012 57.5012 58.6667 56 58.6667H8C6.49883 58.6667 5.33333 57.5012 5.33333 56V8C5.33333 6.49883 6.49883 5.33333 8 5.33333ZM41.25 16C36.754 16 33.0988 19.6552 33.1042 24.1458C33.1042 24.9832 33.3958 25.5442 33.3958 26.1042C26.6545 25.8215 21.0557 22.4608 17.125 17.6875C16.2823 18.8128 16 20.2119 16 21.6146C16 24.4199 17.0931 26.6674 19.3438 28.6354C17.8504 28.4328 17.1253 28.0704 16 27.5104C16 31.4411 18.5029 34.527 22.1563 35.375C22.1563 35.375 20.7489 35.6563 19.9063 35.6563C19.2663 35.6563 18.5 35.375 18.5 35.375C19.6253 38.463 22.43 40.9896 26.0833 40.9896C23.278 42.9576 19.6221 44.3542 15.9688 44.3542H14C16.6667 46.6688 20.6635 48 26.3542 48C41.2395 48 49.3958 35.6563 49.3958 24.9896V23.8646C50.8038 22.7393 52.2027 21.3365 53.3333 19.6458C51.648 20.4938 50.2428 20.7694 48.5521 21.0521C50.2374 19.9321 51.6483 18.5252 52.2083 16.5625C50.8057 17.3998 49.1243 18.2382 47.1563 18.5208C45.7483 16.8408 43.5007 16 41.25 16Z" />
        </svg>
      </a>
      <a className="hover:brightness-110" href="https://www.sexpositivelosangeles.org/resources/discord">
        <svg width="64" height="71" viewBox="0 0 64 71" fill="none" xmlns="http://www.w3.org/2000/svg" title="Discord icon" className="fill-current" style={{width: "30px", height: "30px"}}>
          <path d="M7.11111 0C3.22467 0 0 3.19494 0 7.04555V56.3644C0 60.2127 3.22079 63.4062 7.10417 63.4099L48.6875 63.5063C49.2395 63.5064 49.784 63.3792 50.2778 63.1347L58.2014 69.506C58.7228 69.9259 59.3537 70.1908 60.0208 70.27C60.688 70.3493 61.3641 70.2396 61.971 69.9538C62.5778 69.6679 63.0905 69.2175 63.4496 68.6549C63.8087 68.0922 63.9995 67.4402 64 66.7745V7.04555C64 3.19494 60.7753 0 56.8889 0H7.11111ZM7.11111 7.04555H56.8889V59.3711L50.1667 53.97C49.6617 53.5648 49.0543 53.3044 48.4104 53.2172C47.7666 53.1299 47.1109 53.2191 46.5146 53.4752C45.9184 53.7312 45.4043 54.1442 45.0283 54.6693C44.6523 55.1945 44.4288 55.8117 44.3819 56.4538L7.11806 56.3644C7.11574 56.3644 7.11343 56.3644 7.11111 56.3644V7.04555ZM27.1528 18.1643C22.559 18.6011 19.0694 21.3224 19.0694 21.3224C19.0694 21.3224 14.9333 27.2306 14.2222 38.7712C18.4036 43.5058 24.7292 43.5324 24.7292 43.5324L26.0417 41.7985C24.7012 41.3406 23.5587 40.7531 22.3889 39.8583L22.6319 39.1427C24.8186 40.1326 27.6267 40.7114 32 40.7114C36.3733 40.7114 39.1814 40.1291 41.3681 39.1427L41.6111 39.8583C40.4378 40.7566 39.2952 41.3441 37.9583 41.7985L39.2708 43.5324C39.2708 43.5324 45.5964 43.5058 49.7778 38.7712C49.0667 27.2306 44.9306 21.3224 44.9306 21.3224C44.9306 21.3224 41.2277 18.4884 36.8472 18.1643L35.9444 19.9945C34.604 19.7514 33.2053 19.5748 32 19.5748C30.7556 19.5748 29.3572 19.7415 28.0417 19.967L27.1528 18.1643ZM25.5972 28.1822C27.1617 28.1822 28.4444 29.7604 28.4444 31.705C28.4444 33.6495 27.1617 35.2277 25.5972 35.2277C24.0328 35.2277 22.7569 33.6495 22.7569 31.705C22.7569 29.7604 24.0328 28.1822 25.5972 28.1822ZM38.4028 28.1822C39.9672 28.1822 41.2431 29.7604 41.2431 31.705C41.2431 33.6495 39.9672 35.2277 38.4028 35.2277C36.8383 35.2277 35.5556 33.6495 35.5556 31.705C35.5556 29.7604 36.8383 28.1822 38.4028 28.1822Z" />
        </svg>
      </a>
    </div>
  );
}

// id: "775c98d0-5d5f-417b-9d7f-730a295925b1"
// title: ""
// type: :reference
// key: "header"
// parent_id: "86785c3f-3c71-44e1-b7f4-2cbfd3473d77"
export function Header775c98d05d5f417b9d7f730a295925b1(props: any) {
  return (
    <MembersAreaHeader90b86fff80d6439c9034054455b3a39f parentTag="Header775c98d05d5f417b9d7f730a295925b1" {...props} />
  );
}

// id: "d3752ab5-ef57-425c-869f-4d52f53d9002"
// title: "About Page PostSlug"
// type: :text
// key: "postSlug"
// parent_id: "be1bb880-100f-4579-ba5f-ef4123928a7c"
export const PostSlugD3752ab5Ef57425c869f4d52f53d9002 = "about-page-posts";

// id: "9c2a304a-addb-427f-afb6-2062df89834e"
// title: "About Us - Post Slug"
// type: :text
// key: "postSlug"
// parent_id: nil
export const PostSlug9c2a304aAddb427fAfb62062df89834e = "about-us-posts";

// id: "d2ad43b9-f0ee-4db3-b5ff-7013d864d752"
// title: ""
// type: :reference
// key: "header"
// parent_id: "5f4c8c28-0da6-4c12-84d0-d66e10680d8e"
export function HeaderD2ad43b9F0ee4db3B5ff7013d864d752(props: any) {
  return (
    <SecondaryMarketingHeader6d22da4fD4dc471eB21e0f19910f28bd parentTag="HeaderD2ad43b9F0ee4db3B5ff7013d864d752" title="Join Us" {...props} />
  );
}

// id: "3900bba6-1a9f-4d4f-a325-1b000f8e9389"
// title: "Home Page Body"
// type: :reference
// key: "body"
// parent_id: "7c267767-62b5-43d5-afb6-26575d0a5643"
export function Body3900bba61a9f4d4fA3251b000f8e9389(props: any) {
  return (
    <MarketingBody92fc428dD61c4f3dA18d393bb32c9fe5 parentTag="Body3900bba61a9f4d4fA3251b000f8e9389" postSlug="home-page-posts2" {...props} />
  );
}

// id: "75da0fb9-feef-41f4-938e-f6042ba9089b"
// title: ""
// type: :reference
// key: "header"
// parent_id: "8ac4aff8-0a26-424e-9003-f896586e9d3a"
export function Header75da0fb9Feef41f4938eF6042ba9089b(props: any) {
  return (
    <SecondaryMarketingHeader6d22da4fD4dc471eB21e0f19910f28bd parentTag="Header75da0fb9Feef41f4938eF6042ba9089b" title="About Us" {...props} />
  );
}

// id: "dfab34d6-20b5-4a91-a0e4-9f59fe1008e4"
// title: ""
// type: :text
// key: "title"
// parent_id: "7b527641-531b-4e36-8315-de2e2a0e2db0"
export const TitleDfab34d620b54a91A0e49f59fe1008e4 = "Join Us";

// id: "8024c0c4-2eeb-463d-9e10-80e9743e8649"
// title: "Logo"
// type: :html
// key: "default-logo"
// parent_id: nil
export function DefaultLogo8024c0c42eeb463d9e1080e9743e8649(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <img src="https://mp1md-pub.s3.amazonaws.com/spla/images/spla-logo.png" className={`${parentTag || ""} DefaultLogo8024c0c42eeb463d9e1080e9743e8649 logo`} alt="logo" />
  );
}

// id: "85b62f96-3b3a-4c25-beb2-7f1bdc66759f"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "e381957f-fd39-45cd-a6d0-634e57ec798c"
export function HeaderTop85b62f963b3a4c25Beb27f1bdc66759f(props: any) {
  return (
    <DefaultHeaderTop1ef5bcc6F3ec41deBc3c8610d1bec5c7 parentTag="HeaderTop85b62f963b3a4c25Beb27f1bdc66759f" {...props} />
  );
}

// id: "269dfa7b-f2f3-4f2c-9dd2-d0750f4bc877"
// title: ""
// type: :text
// key: "title"
// parent_id: "09249255-62b3-4385-83c8-09987930342c"
export const Title269dfa7bF2f34f2c9dd2D0750f4bc877 = null;

// id: "d5232a57-1c78-4d3b-8e90-621c85e9938b"
// title: ""
// type: :html
// key: "logo"
// parent_id: "25b5a401-e65a-4c25-886a-dce4af827452"
export function LogoD5232a571c784d3b8e90621c85e9938b(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <img src="https://mp1md-pub.s3.amazonaws.com/spla/images/spla-logo.png" alt="SPLA logo" className={`${parentTag || ""} LogoD5232a571c784d3b8e90621c85e9938b logo`} />
  );
}

// id: "54519e49-835b-4aaf-b1a8-54ff220652c4"
// title: ""
// type: :text
// key: "title"
// parent_id: "a3b32a5c-1ab9-4b83-9bc5-0d122571ed17"
export const Title54519e49835b4aafB1a854ff220652c4 = "Secondary Marketing Title 2";

// id: "6d22da4f-d4dc-471e-b21e-0f19910f28bd"
// title: "Secondary Marketing Header"
// type: :html
// key: "secondary-marketing-header"
// parent_id: nil
export function SecondaryMarketingHeader6d22da4fD4dc471eB21e0f19910f28bd(props: any) {
  const { parentTag, ...rest } = props;
  props = { title: "Secondary Marketing Title 1", ...rest };
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHeader6d22da4fD4dc471eB21e0f19910f28bd site-header`}>
      <div className="background-color" />
      <div className="background-image" />
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTop1ef5bcc6F3ec41deBc3c8610d1bec5c7 parentTag="HeaderTop194daa5a66764701985679b5e228fcc9" {...props} />}
      </div>
      {props["hero"] || <SecondaryMarketingHeroDee3491731424a41Ad45684a5d16f568 parentTag="HeroA3b32a5c1ab94b839bc50d122571ed17" title="Secondary Marketing Title 2" {...props} />}
    </div>
  );
}

// id: "517d57ba-73c2-4585-b659-689dff2bdade"
// title: ""
// type: :reference
// key: "header"
// parent_id: "083a5a17-4423-498b-a547-8d1c92b1a39b"
export function Header517d57ba73c24585B659689dff2bdade(props: any) {
  return (
    <SecondaryMarketingHeader6d22da4fD4dc471eB21e0f19910f28bd parentTag="Header517d57ba73c24585B659689dff2bdade" title="Secondary Page" {...props} />
  );
}

// id: "0d06ac63-90fb-4994-a919-ff63b417cc2a"
// title: ""
// type: :text
// key: "title"
// parent_id: "dee34917-3142-4a41-ad45-684a5d16f568"
export const Title0d06ac6390fb4994A919Ff63b417cc2a = "Default Title";

// id: "7b527641-531b-4e36-8315-de2e2a0e2db0"
// title: ""
// type: :reference
// key: "header"
// parent_id: "77e6c1cf-fbd1-485a-b044-20f508269353"
export function Header7b527641531b4e368315De2e2a0e2db0(props: any) {
  return (
    <SecondaryMarketingHeader6d22da4fD4dc471eB21e0f19910f28bd parentTag="Header7b527641531b4e368315De2e2a0e2db0" title="Join Us" {...props} />
  );
}

// id: "6cde8820-43da-405d-a05c-f7438291d247"
// title: ""
// type: :text
// key: "class"
// parent_id: "9e4b683c-014b-4da4-91d6-bb438460500d"
export const Class6cde882043da405dA05cF7438291d247 = "linked-logo";

const Components = {
  MemberPagesDd3879f03f21403aAa00045afeb31cb2,
  MarketingBody92fc428dD61c4f3dA18d393bb32c9fe5,
  Header95203a5cBe42476f8e9bEae728e4892c,
  Footer243def2d621b43d193e534316ad9abfe,
  WelcomeBackCe60aaa7Eca54413B40788b90d11c72b,
  Label5cefc4bfEab64655Abc043adcd21c17a,
  Footer86c498fc2ea9476fA89f7e61e29969ed,
  HeaderF0ca1dc49f8b4f0dB64b45824eb047fe,
  Footer47b8a8bf5acc4d3eB66f0a6a410a058e,
  FooterEf1989c6Df8f40f2B0a83ac18d026ffa,
  NavMenuSlug7a5e3e8165d04aceAe514baadfaea45f,
  DefaultHeaderTop1ef5bcc6F3ec41deBc3c8610d1bec5c7,
  Groupflow9a4d546504f044498a2a821a291fae07,
  SecondaryNav339ae8cfDc9f4668B920D15041925fcf,
  NavMenuSlugBa1bd02cE23b4b24Ab6b43bc563f1a12,
  MembersAreaHeader90b86fff80d6439c9034054455b3a39f,
  SecondaryMarketingHeroDee3491731424a41Ad45684a5d16f568,
  SocialLinks5e89e9e8Eb6c4278B6b59b92b282d82f,
  HeroA73719697a4646b18864A6e4fa95056f,
  MarketingCardsE2bb597b38e244459a9eE2dcf0fb8adf,
  Title0cea909fB34a4751Bb1784ad2ecb7ecd,
  PasswordResetPage87067b3dC7864aafB66c44797d6193df,
  SignupPages5f4c8c280da64c1284d0D66e10680d8e,
  FooterCbb3550dA7914464975a602f143a8921,
  Header342d05e4B74a4433A6024f9c0028e676,
  NavMenuSlug2c3691474691412d8a947ed65ea760c0,
  PostSlugA8df3b7d9f5f4429823f6a4ba2faa31a,
  SecondaryPage083a5a174423498bA5478d1c92b1a39b,
  PageQuoteB97b5b3089454394A19aAe874d6c6257,
  HeaderTop194daa5a66764701985679b5e228fcc9,
  Footer53c10fe4342f47ed8552879a2b7d378e,
  Class59c0ab6aF32c49478c560a73eacf59d4,
  Label702a46f09dd34bc6B0da2a2fdffcb34a,
  DefaultFooter25b5a401E65a4c25886aDce4af827452,
  MarketingCards7218b3e0688a46d4A366Db928170574a,
  LinkedLogo9e4b683c014b4da491d6Bb438460500d,
  HeroA3b32a5c1ab94b839bc50d122571ed17,
  LabelB77340855d614373B79b51faaec30dee,
  Href1d760e6e8c3948f0A61c31b0bb8acd2f,
  MembersAreaDefaultF690f263A736435182539cebc7a00478,
  HomeHeaderE381957fFd3945cdA6d0634e57ec798c,
  Footer7e750485500b4b21B593F15da9fb3129,
  ButtonClass9356fba6C28e4780Bc86E53011560f9e,
  Title98fd4fd6527c43508dc9Ab3c8a321549,
  AdminPagesE674cbda071d4c4b85cfA06f6ec3af19,
  JoinUsPage77e6c1cfFbd1485aB04420f508269353,
  Links66baa37364a34c07A3dbDaa5a3f4e9bb,
  HeaderTop08fd47fcFb374ee984beAb991592fb7f,
  UrlAb7bba6dE65949be8288190acf27d88f,
  Href4031dff9C8db4cb4A9263add7f96537f,
  HomePageHero322f2d2f489b4087A094005114177d63,
  BackgroundImage13834b22C7b74385Aeb1A409ca189827,
  CopyrightE061694737714a759e33B61f6a63e14a,
  Title97de754cDa074bae86571d7543cbaad4,
  ShortHeaderF599bc4983364fbf88ad8999fcb67518,
  HomePage7c26776762b543d5Afb626575d0a5643,
  Header109883060ebf42c5B3550600028af36d,
  Header9025786813464eddBa754df5b4074c05,
  TitleF11d7083702a46459b93F229c5e7a0ac,
  AboutUsPage8ac4aff80a26424e9003F896586e9d3a,
  MessagePages86785c3f3c7144e1B7f42cbfd3473d77,
  SocialLinks425cd5153f7a460281c4A39846d991af,
  BodyBe1bb880100f4579Ba5fEf4123928a7c,
  TitleE495b5d5Db1f440893ad9cc4df489e4d,
  HeaderD9e6b5cb476f4648B97d1ea6e209b31b,
  PublicEventsPageF999e539E9a848fe92d8537de632b12a,
  Header32c1b2db50d34558B55765b1cac456cd,
  NavMenuSlug946c97a55e8843319198Da16e9d9071b,
  PostSlugFb3c29a9D7ab499c85daDe1361244f52,
  DefaultHeader0924925562b3438583c809987930342c,
  NavigationC841746490764ab7Aacb2f696df9077a,
  LinkedLogo2eef6fa35f4b49088968D13f12e3d1b2,
  HeaderC93f454d2b804e12AebbA1330028c898,
  NavMenuSlug0d1071fe64784d1280107b53abb05edf,
  ResourcesPageC1007033E4ac4a298d6bAcd4a49458dd,
  Button1e537b3bC27b4227BfafF2fc2babd6e9,
  Title21508ae4Abd347ebA4a84c7fed005683,
  Title23c11ec651d2461eBca47a77081bb643,
  Label852954244e754547A498E1e65c58be45,
  Alt85fb651898094fcf9e5c373537b80d8d,
  Footer3013773d45a244859fa2C457edd48b6b,
  QuoteFa612e8c7939417b890a1bb64fc9f5a3,
  NavMenuSlug2e693d7262ae4cf0B5a07b1473872051,
  LoginPageD342b899508447d9896aF6109019de60,
  Navigation3653855aDf874b5cB1d8D2bf18b46ad9,
  SocialLinksB4a1ea5d9a32404996c38c7ab61a157d,
  Header775c98d05d5f417b9d7f730a295925b1,
  PostSlugD3752ab5Ef57425c869f4d52f53d9002,
  PostSlug9c2a304aAddb427fAfb62062df89834e,
  HeaderD2ad43b9F0ee4db3B5ff7013d864d752,
  Body3900bba61a9f4d4fA3251b000f8e9389,
  Header75da0fb9Feef41f4938eF6042ba9089b,
  TitleDfab34d620b54a91A0e49f59fe1008e4,
  DefaultLogo8024c0c42eeb463d9e1080e9743e8649,
  HeaderTop85b62f963b3a4c25Beb27f1bdc66759f,
  Title269dfa7bF2f34f2c9dd2D0750f4bc877,
  LogoD5232a571c784d3b8e90621c85e9938b,
  Title54519e49835b4aafB1a854ff220652c4,
  SecondaryMarketingHeader6d22da4fD4dc471eB21e0f19910f28bd,
  Header517d57ba73c24585B659689dff2bdade,
  Title0d06ac6390fb4994A919Ff63b417cc2a,
  Header7b527641531b4e368315De2e2a0e2db0,
  Class6cde882043da405dA05cF7438291d247
}

export default Components;